module.exports = __webpack_public_path__ + "static/p-boarding-smg-fc5f25dbd909990ddf80b08823e9e7e7.jpg";